import createApi from './api';

export const StatType = {
  containerDetails: {
    name: 'containerDetails',
    path: '/container-details',
  },
  doorDetails: {
    name: 'doorDetails',
    path: '/door-details',
  },
  // employeeDetails: {
  //   name: 'employeeDetails',
  //   path: '/employee-details',
  // },
  individualDetails: {
    name: 'individualDetails',
    path: '/individual-details',
  },
  p4p: {
    name: 'p4p',
    path: '/p4p',
  },
  // containers: {
  //   name: 'containers',
  //   path: '/containers',
  // },
  employeesLive: {
    name: 'employeesLive',
    path: '/employees-live',
  },
  employeesChecked: {
    name: 'employeesChecked',
    path: '/employees-checkin',
  },
  employeeStats: {
    name: 'employeeStats',
    path: '/employee-stats',
  },
  employeeGoals: {
    name: 'employeeGoals',
    path: '/employee-goals',
  },
  locationsLive: {
    name: 'locationsLive',
    path: '/location-live',
  },
  teamStats: {
    name: 'teamStats',
    path: '/team-stats',
  },
  timeline: {
    name: 'processTimeline',
    path: '/timeline',
  },
  screenshots: {
    name: 'processLiveCamera',
    path: '/screenshots',
  },
  unloadStats: {
    name: 'unloadStats',
    path: 'unload-stats',
  },
  loadStats: {
    name: 'loadStats',
    path: 'unload-stats',
  },
  cartStats: {
    name: 'cartStats',
    path: 'cart-stats'
  },
  cartDetails: {
    name: 'cartDetails',
    path: 'cart-details',
  },
  cartFlow: {
    name: 'cartFlow',
    path: 'cart-flow',
  },
  cartStatsShift: {
    name: 'cartStatsShift',
    path: 'cart-stats-shift',
  }
};

export default class StatsService {
  constructor(statType) {
    this.statType = statType;
    this.api = createApi({
      baseUrl: `reports`,
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async loadStats(data) {
    return this.api.post(this.statType.path, data);
  }
}
